import axiosInstance from '../axiosInterceptor/axiosInstance'

const activateCoupon = (data) => {
  const { couponCode, orgId } = data
  const url = `v1/orgs/${orgId}/billing/coupons`
  return axiosInstance.post(url, { couponCode }, { skipErrorNotification: true })
}

export default activateCoupon
